import React, { useMemo, useState } from 'react'

import { CubeFilterDimensions } from 'cube'
import { CubeOperator } from 'cube/components/CubeReportFilterRow'
import { useSelector } from 'react-redux'

import { Flex, Select } from '@driftt/dds'

import { teams } from 'modules/teams/selectors'

import Availability from './TeammateAvailability'

const AvailabilityPage = () => {
  const allTeams = useSelector(teams)
  const [selectedFilters, setSelectedFilters] = useState<number[]>([])
  const [selectedTeamIds, setSelectedTeamIds] = useState<number[]>([])

  const availableOptions = useMemo(
    () =>
      allTeams.map(({ name, id }) => ({
        label: name,
        value: id,
      })),
    [allTeams]
  )

  const formatedFilters = useMemo(
    () =>
      selectedTeamIds.length
        ? [
            {
              member: CubeFilterDimensions.TEAM_PARTICIPATED_TEAM_ID,
              operator: CubeOperator.EQUALS,
              values: selectedTeamIds.map((id) => id.toString()),
            },
          ]
        : [],
    [selectedTeamIds]
  )

  return (
    <Flex fullWidth direction="column" gap={3}>
      <Select
        label="Team"
        hideLabel
        placeholder="Select team..."
        multi
        options={availableOptions}
        onChange={(team: any) => {
          setSelectedFilters(team.map((item) => item.value))
        }}
        onBlur={() => setSelectedTeamIds(selectedFilters)}
      />
      <Availability teamFilters={formatedFilters} />
    </Flex>
  )
}

export default AvailabilityPage
